import { memo, useState, useCallback } from 'react';
import StackTextField from 'components/cmn/StackTextField';
import useWidth from 'hooks/useWidth';
import { Button, Stack } from '@mui/material';
import isEmpty from 'lodash/isEmpty';
import { useAppDispatch } from 'store';
import { showMessage } from 'store/message/messageSlice';
import { useProject } from 'hooks/useProject';

function UserSearch(): JSX.Element {
  const dispatch = useAppDispatch();
  const { changeAccountsListSearchCondition, accountsListSearchCondition } = useProject();
  const { compName, name } = accountsListSearchCondition;
  const [_compName, setCompName] = useState(compName);
  const [_name, setName] = useState(name);

  const width = useWidth();
  const isPc = ['lg', 'xl'].includes(width);
  const isTablet = ['md'].includes(width);
  const isMobile = ['xs', 'sm'].includes(width);
  let dynamicWidth = '400px';
  if (isPc) {
    dynamicWidth = '400px';
  } else if (isTablet) {
    dynamicWidth = '250px';
  } else if (isMobile) {
    dynamicWidth = '100%';
  }

  const handleSearchReset = useCallback(() => {
    setCompName('');
    setName('');
    changeAccountsListSearchCondition({
      ...accountsListSearchCondition,
      compName: '',
      name: '',
    });
  }, [accountsListSearchCondition, changeAccountsListSearchCondition]);

  const handleSearchClick = () => {
    if (isEmpty(_compName) && isEmpty(_name)) {
      dispatch(showMessage({ message: '적어도 하나의 필드는 입력해야합니다.', variant: 'warning' }));
    }
    changeAccountsListSearchCondition({
      ...accountsListSearchCondition,
      compName: _compName,
      name: _name,
    });
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      handleSearchClick();
    }
  };

  return (
    <Stack
      direction={isMobile ? 'column' : 'row'}
      spacing="24px"
      sx={{ display: 'flex', alignItems: 'center', pt: 2, justifyContent: 'flex-start' }}
    >
      <Stack
        direction="column"
        sx={{ display: 'flex', alignItems: isMobile ? 'flex-start' : 'center', p: 0, overflow: 'auto' }}
      >
        <StackTextField
          essential={false}
          label="강사 소속"
          name="_compName"
          text={_compName}
          directionType="custom"
          labelSx={{ fontSize: 16, fontWeight: 700 }}
          labelWidth={110}
          width={dynamicWidth}
          onChange={e => setCompName(e.target.value)}
          onKeyPress={handleKeyPress}
        />
        <StackTextField
          essential={false}
          label="강사 이름"
          name="_name"
          text={_name}
          directionType="custom"
          labelSx={{ fontSize: 16, fontWeight: 700 }}
          labelWidth={110}
          width={dynamicWidth}
          onChange={e => setName(e.target.value)}
          onKeyPress={handleKeyPress}
        />
      </Stack>
      <Button variant="contained" color="primary" onClick={handleSearchClick} sx={{ height: 40 }}>
        검색
      </Button>
      {(!isEmpty(_compName) || !isEmpty(_name)) && (
        <Button variant="outlined" color="primary" onClick={handleSearchReset} sx={{ height: 40 }}>
          초기화
        </Button>
      )}
    </Stack>
  );
}

export default memo(UserSearch);
